"use strict";
exports.__esModule = true;
exports.errorText = 'Введен некорректный email';
var validateEmail = function (email) {
    if (!email) {
        return '';
    }
    var _a = email.split('@'), user = _a[0], domain = _a[1];
    if (!user || !domain) {
        return exports.errorText;
    }
    var isValidDomain = domain.split('.').filter(Boolean).length > 1;
    if (!isValidDomain) {
        return exports.errorText;
    }
    return '';
};
exports["default"] = validateEmail;
